import { Flex, Text } from '@chakra-ui/react';
import { Switch, Select, type SelectOption } from '@kula-ai/components';
import { Stars03, LayoutLeft } from '@kula-ai/icons-core';
import type { ScorecardStepCopy } from './ScorecardStep.types';

interface ScorecardStepHeaderProps {
  scorecardEnabled: boolean;
  onScorecardEnabledChange: (_enabled: boolean) => void;
  aiEnabled: boolean;
  onAiEnabledChange: (_enabled: boolean) => void;
  showAiToggle?: boolean;
  templateOptions: SelectOption[];
  selectedTemplate: string | null;
  onTemplateChange: (_value: string | null) => void;
  copy: ScorecardStepCopy;
}

export const ScorecardStepHeader = ({
  scorecardEnabled,
  onScorecardEnabledChange,
  aiEnabled,
  onAiEnabledChange,
  showAiToggle = true,
  templateOptions,
  selectedTemplate,
  onTemplateChange,
  copy,
}: ScorecardStepHeaderProps) => (
  <Flex flexDir="column" gap="4" w="100%">
    <Flex
      align="center"
      justify="space-between"
      p="4"
      bg="gray.50"
      borderRadius="sm"
    >
      <Text fontSize="sm" fontWeight="medium">
        {copy.enableLabel}
      </Text>
      <Switch
        checked={scorecardEnabled}
        onCheckedChange={onScorecardEnabledChange}
      />
    </Flex>

    {scorecardEnabled && (
      <>
        {showAiToggle && (
          <Flex
            align="center"
            justify="space-between"
            px="4"
            py="3"
            borderRadius="sm"
            bg="#F9F5FF"
          >
            <Flex align="center" gap="2">
              <Stars03 size={16} color="var(--chakra-colors-primary-500)" />
              <Flex flexDir="column">
                <Text fontSize="sm" fontWeight="medium" color="patel-3-light">
                  {copy.aiLabel}
                </Text>
                <Text fontSize="xs" color="secondary.500">
                  {copy.aiDescription}
                </Text>
              </Flex>
            </Flex>
            <Switch checked={aiEnabled} onCheckedChange={onAiEnabledChange} />
          </Flex>
        )}

        <Select
          options={templateOptions}
          value={selectedTemplate ?? undefined}
          onChange={(val) => onTemplateChange((val as string) || null)}
          placeholder={copy.templatePlaceholder}
          isClearable
          beforeElement={
            <LayoutLeft
              size={18}
              className="-mr-2 ml-1 shrink-0 text-secondary-500"
              aria-hidden
            />
          }
        />
      </>
    )}
  </Flex>
);
